import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import InvoiceExportModal from "../../../../invoice/exportmodal.component"
import { ObjectType } from "../../../../state/listing/generic-listing"
import { SearchPayload } from "../../../../state/search/SearchPayload"
import Icon from "../../../icon/icon.component"

interface OwnProps {
    exportType: ObjectType
    filters: SearchPayload
}

const InvoiceExportModalWrapper = (props: OwnProps) => {
    const [show, setShow] = useState<boolean>(false)

    return (
        <>
            <button
                onClick={() => setShow(true)}
                className="btn btn-sm btn-secondary"
            >
                <Icon value='file-export' className='mr-1' />
                <FormattedMessage
                    id="generic-listing.export-all"
                    defaultMessage="Export all results"
                />
            </button>

            {show && (
                <InvoiceExportModal
                    exportType={props.exportType}
                    filters={props.filters}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}

export default InvoiceExportModalWrapper


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/export-modals/InvoiceExportModal.tsx